<template>
  <v-container>
    <div
      class="display-2 mb-7 mt-5 font-weight-thin"
      color="primary"
    >{{$tc('entities.environment.title',2)}}</div>

    <alert-box v-model="alert.alerts" :type="alert.type" @close="alert.alerts = []"></alert-box>
    <btn-a rounded color="primary" @click="editItem" :access="$access.environment.edit">
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <table-grid
      :headers="headers"
      :items="items"
      :loading="loadingTable"
      :loadingAction="loadingDialog"
      :actions="actions"
      :page="pagination.page"
      :pageLength="lengthPaginationComp"
       @input="pagination.page = $event"
    @search="searchTable"
    />

    <dialog-d
      ref="dialogEdit"
      :title="$tc('entities.environment.title',1)"
      :deleteButton="itemSelected && itemSelected.id"
      @confirm="saveItem(itemSelected,$refs.form.isValid())"
      @delete="deleteItem(itemSelected,true)"
      :loading="loadingDialog"
      :accessConfirm="$access.environment.edit"
      :accessDelete="$access.environment.delete"
      :alert="form.alert"
    >
      <environmentForm v-if="itemSelected" ref="form" v-model="itemSelected" />
    </dialog-d>
  </v-container>
</template>

<script>
import environmentService from "@/services/environmentService"
import environmentForm from "../components/forms/environments/environmentForm";
import pageListMixing from "../mixins/pageLists/pageListMixing.js";
export default {
  mixins: [pageListMixing],
  components: { environmentForm },

  data() {
    return {
      apiController: "environment",
      entityService : environmentService,
      searchFields: ["description"],
      headers: [
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "description"
        },
        {
          text: this.$t("table.actions"),
          value: "action",
          sortable: false,
          align: "right"
        }
      ],
      actions: [
        {
          text: this.$t("edit"),
          icon: "mdi-pencil",
          handle: this.editItem,
          access: [this.$access.environment.edit, this.$access.environment.show]
        },
        {
          text: this.$t("delete"),
          icon: "mdi-delete",
          handle: this.deleteItem,
          access: this.$access.environment.delete
        }
      ]
    };
  },
  methods: {
    getModelDefault() {
      return {
        description: "",
        jobStatus: [],
        jobStageStatus: [],
        calendarProds: [],
        calendarExcs: []
      };
    }
  },
  async mounted() {
    await this.getItems();
  }
};
</script>